import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import Link from '@material-ui/core/Link';

import NewButton from 'components/molecules/NewButton';
import ContentsWrap from 'components/molecules/ContentsWrap';
import BarGraph from 'components/organisms/Chart/BarGraph';

import AudienceUserGraph from './AudienceUserGraph';
import AdidStatusGraph from './AdidStatusGraph';
import AudienceNewGraph from './AudienceNewGraph';

let initParam = {
  sDate: moment().add(-1, 'day').add(-1, 'month').format('YYYYMMDD'),
  eDate: moment().add(-1, 'day').format('YYYYMMDD'),
};

const StatusStatistics = (props) => {
  const { cookieParamGraph, cookieGraphList, appadiddayGraph, adidGraphList } =
    props;
  const { t } = useTranslation();

  const [params] = useState(initParam);

  return (
    <>
      <ContentsWrap contentsCount={2}>
        <BarGraph
          titleLink={
            <Link href="/report/datacenter/cookie">
              <NewButton
                icon="faExternalLink"
                iconBtn
                disableRipple
                style={{ marginRight: 10 }}
              />
            </Link>
          }
          params={params}
          dataReqPromise={cookieParamGraph}
          graphList={cookieGraphList}
          title={t('유저 모수 현황')}
          labelType="DD"
        />
        <AudienceUserGraph params={params} type="main" />
      </ContentsWrap>
      <ContentsWrap contentsCount={2}>
        <AdidStatusGraph
          params={params}
          type="main"
          appadiddayGraph={appadiddayGraph}
          adidGraphList={adidGraphList}
        />
        <AudienceNewGraph params={params} type="main" />
      </ContentsWrap>
    </>
  );
};

export default StatusStatistics;
